import React, { Component } from "react";
import { Form, Input, InputNumber, Button, Divider, message } from "antd";
import styles from "../index.module.less";
import { inject, observer } from "mobx-react";
import { checkArticleBalance } from "services/options";
import co from "co";

const FormItem = Form.Item;

@Form.create({
	onFieldsChange(props, changedFields) {
		props.onFieldsChange(changedFields);
	},
	mapPropsToFields(props) {
		return props.fields;
	}
})
@observer
class ArticleBuilderForm extends Component {
	// validateForm = (callback) => {
	// 	this.props.form.validateFieldsAndScroll(callback);
	// }

	render() {
		const balanceText = <span><b>Balance:</b> {this.props.balance}</span>;
		return (
			<Form layout="vertical" className={styles.rxform}>
				<FormItem label="Username">
					{this.props.form.getFieldDecorator("articleBuilder.username")(
						<Input type="text" />
					)}
				</FormItem>
				<FormItem label="Password">
					{this.props.form.getFieldDecorator("articleBuilder.password")(
						<Input type="text" />
					)}
				</FormItem>
				<FormItem label="Number of Articles to Spin Together">
					{this.props.form.getFieldDecorator("articleBuilder.articleCount", {
						rules: [
							{
								type: "integer",
								min: 1,
								message: "Must be a number larger or equal to 1"
							}
						]
					})(<InputNumber min={1}/>)}
				</FormItem>
				<FormItem>
					<Button type="primary" onClick={this.props.checkBalance} loading={this.props.checking}>Check Balance</Button>
				</FormItem>
				<Divider type="horizontal" />
				{balanceText}
			</Form>
		);
	}
}

@inject("rootStore")
@observer
class ArticleBuilder extends Component {
	constructor(props) {
		super(props);
		this.state = {
			checking: false,
			result: ""
		}
	}
	// validateForm = () => {
	// 	return new Promise(resolve => {
	// 		this.internalForm.validateForm((err, vals) => {
	// 			resolve(err);
	// 		});
	// 	});
	// };

	checkBalance = () => {
		const {
			rootStore: { optionsStore }
		} = this.props;		
		
		const options = optionsStore.stateForm;
		const username = options.articleBuilder.username ? options.articleBuilder.username.value : "";
		const password = options.articleBuilder.password ? options.articleBuilder.password.value : "";
		if (!username || !password) {
			//do nothing;
			return;
		}
		co (function*() {
			this.setState({
				checking: true
			})

			const response = yield checkArticleBalance({
				articleSource: "ArticleBuilder",
				inputInfo: JSON.stringify({
					username: username,
					password: password,
					articleCount: 1
				})
			})

			this.setState({
				checking: false
			})

			if (!response) {
				message.error("Failed to check Article Builder balance. Unknown error.");
				return;
			}

			if (response.error) {
				message.error(response.error.message);
				return;
			}

			this.setState({
				balance: response.balance
			})
		}.bind(this))

	}

	onFieldsChange = changedFields => {
		const {
			rootStore: { optionsStore }
		} = this.props;		

		optionsStore.formChanged(changedFields);
	};

	mapPropsToFields = () => {
		const {
			rootStore: { optionsStore }
		} = this.props;

		const options = optionsStore.stateForm;

		return {
			articleBuilder: {
				username: Form.createFormField(options.articleBuilder.username),
				password: Form.createFormField(options.articleBuilder.password),
				articleCount: Form.createFormField(options.articleBuilder.articleCount)
			}
		};
	};

	render() {
		return (
			<ArticleBuilderForm
				fields={this.mapPropsToFields()}
				onFieldsChange={this.onFieldsChange}
				checking={this.state.checking}
				balance={this.state.balance}
				checkBalance={this.checkBalance}
				wrappedComponentRef={internalForm => {
					this.internalForm = internalForm;
				}}
			/>
		);
	}
}

export default ArticleBuilder;
